import React from "react";

/**
 * Meetmotief: een lat met schaalstreepjes. Het terugkerende grafische element van Fulkra Works —
 * dit is een meetbedrijf, en dat mag je zien. Elke vijfde streep is langer.
 */
export function MeasureRule({ orientation = "horizontal", height = 14, spacing = 8, color = "var(--lijn-sterk)", accent, style }) {
  const horizontaal = orientation === "horizontal";
  const kleur = accent || color;
  const kort = Math.round(height * 0.4);
  const hoek = horizontaal ? "90deg" : "0deg";
  const lat = (afstand) => "repeating-linear-gradient(" + hoek + ", " + kleur + " 0 1px, transparent 1px " + afstand + "px)";
  const buiten = horizontaal ? { width: "100%", height } : { height: "100%", width: height };
  const laag = (dikte, offset) => horizontaal
    ? { left: 0, right: 0, height: dikte, bottom: offset }
    : { top: 0, bottom: 0, width: dikte, right: offset };
  return (
    <div aria-hidden="true" style={{ ...buiten, position: "relative", overflow: "hidden", ...style }}>
      <div style={{ position: "absolute", ...laag(kort, 0), background: lat(spacing) }} />
      <div style={{ position: "absolute", ...laag(height, 0), background: lat(spacing * 5) }} />
    </div>
  );
}
